import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Label, Panel } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';
import { IListItem } from '@nkr/models/index';
import { FormEvent } from 'react';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    surgeryDate: string,
    organType: number,
    validation: IValidation,
    dirty: boolean,
    isAddingDonor: boolean,
    organTypeList: IListItem[],
    isExpertSystemCenter?: boolean,
    onDataChange: (field: string, value: any) => void
}

const SurgeryDetails = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { id, value } = e.currentTarget;
        props.onDataChange(id, value);
    };

    return (
        <Panel>
            <Panel.Heading>Surgery Details</Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <FormGroup validationState={props.dirty && (!props.validation.surgeryDate || !props.validation.surgeryBilled || !props.validation.surgeryInsurance) ? 'error' : null}>
                        <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Surgery Date:</Col>
                        <Col xs={12} lg={6}>
                            <MaskedInput
                                id='surgeryDate'
                                className='form-control'
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                style={{ borderColor: props.validation.surgeryDate && props.validation.surgeryBilled && props.validation.surgeryInsurance ? '#ccc' : '#a94442' }}
                                value={props.surgeryDate}
                                onChange={handleFieldChange}
                            />

                            {!props.validation.surgeryInsurance && props.isAddingDonor && (
                                <HelpBlock><Label bsStyle="danger" bsSize="large">Surgery Date must be in the future or current month to be insurable.</Label></HelpBlock>
                            )}

                            {!props.validation.surgeryBilled && !props.isAddingDonor && (
                                <HelpBlock><Label bsStyle="danger" bsSize="large">Surgery Date cannot be changed after it has been billed.</Label></HelpBlock>
                            )}

                            {!props.validation.surgeryInsurance && !props.isAddingDonor && (
                                <HelpBlock><Label bsStyle="danger" bsSize="large">Surgery Date cannot be changed to a month in the past due to insurance requirements.</Label></HelpBlock>
                            )}
                        </Col>
                    </FormGroup>

                    {(site.organType != OrganType.Liver || props.isExpertSystemCenter) && (
                        <FormGroup validationState={props.dirty && !props.validation.organType ? 'error' : null}>
                            <Col xs={12} lg={3} lgOffset={1} componentClass={ControlLabel}>Organ Type:</Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    id='organType'
                                    value={props.organType}
                                    disabled={props.isExpertSystemCenter}
                                    onChange={handleFieldChange}
                                >
                                    <option value={-1}>- Please Select -</option>
                                    {props.organTypeList.map(item =>
                                        <option key={'organ-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>
                    )}
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default SurgeryDetails;